// @flow

import React, { Component } from "react";
import Main from "../components/Main";
import Quiz from "../components/Quiz/Quiz";
import { steps, questions } from "../data/quizData";

import type { Step } from "../data/quizData";

export default class QuizPage extends Component {
  getStep = (id: string): Step => steps[id];

  render() {
    return (
      <div className="quiz">

        <Quiz
          firstStep={steps.intro}
          getStep={this.getStep}
          questions={questions}
          showQRCode={false}
        />

        <style jsx global>{`
          html, body {
            height: 100%;
          }
          body {
            margin: 0;
            text-rendering: optimizeLegibility;
            -webkit-font-smoothing: antialiased;
            -moz-font-smoothing: grayscale;
          }
        `}</style>
        <style jsx>{`
          .quiz {
            background: #EEF4F0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            height: 100vh;
          }
        `}</style>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/quiz.js